import { config } from '../config'
import {
  SubTitle,
  Title,
  List,
  ListItem,
  BlockWrapper,
  Article,
} from '../styles'

const {
  challenges: { text, title },
} = config

export function Challenge() {
  return (
    <BlockWrapper>
      <Title as="h2">{title}</Title>
      {text.map(({ id, text, challenges }) => (
        <Article key={id}>
          <SubTitle>{text}</SubTitle>
          {challenges && (
            <List>
              {challenges.map(({ id, title }) => (
                <ListItem key={id}>{title}</ListItem>
              ))}
            </List>
          )}
        </Article>
      ))}
    </BlockWrapper>
  )
}
